import { PayloadAction } from "app/core/models/action";
import { Type, Category, Software } from "app/profile/models/software.model";
import { SearchResult } from "app/profile/models/generic.model";

export const GET_SOFTWARE_TYPES = "[SOFT] GET_SOFTWARE_TYPES";
export const GET_SOFTWARE_TYPES_SUCCESS = "[SOFT] GET_SOFTWARE_TYPES_SUCCESS";
export const GET_SOFTWARE_CATEGORIES = "[SOFT] GET_SOFTWARE_CATEGORIES";
export const GET_SOFTWARE_CATEGORIES_SUCCESS =
    "[SOFT] GET_SOFTWARE_CATEGORIES_SUCCESS";

export class GetSoftwareTypes implements PayloadAction {
    readonly type = GET_SOFTWARE_TYPES;
    constructor(public payload: string, public forceReload: boolean = false) { }
}
export class GetSoftwareTypesSuccess implements PayloadAction {
    readonly type = GET_SOFTWARE_TYPES_SUCCESS;
    constructor(public payload: Type[]) { }
}

export class GetSoftwareCategories implements PayloadAction {
    readonly type = GET_SOFTWARE_CATEGORIES;
    constructor(public payload?: any) { }
}
export class GetSoftwareCategoriesSuccess implements PayloadAction {
    readonly type = GET_SOFTWARE_CATEGORIES_SUCCESS;
    constructor(public payload: Category[]) { }
}

export type SoftwareActions =
    | GetSoftwareTypes
    | GetSoftwareTypesSuccess
    | GetSoftwareCategories
    | GetSoftwareCategoriesSuccess;
